/**
 * 
 * @param {*} result 
 * @param {*} callback 
 */
window.capency = {}

/**
 * @function showCapencyVerifyResult show poping verify address 
 * @param {result} 
 * @param {callback} 
*/
function showCapencyVerifyEmailResult(result, currentEmail) {

    if (result && result.returnCode === 1) {
        if (result.sMessage) {
            var $emailSelector = $('input[name$="_email"]');
            $emailSelector.next('.invalid-feedback').empty().html(result.sMessage).show();
            $emailSelector.addClass("is-invalid");
            $emailSelector.attr('data-validate-email',false);
           $.spinner().stop();
        }
        return false;
    }

    if (result && result.returnCode !== 0 && result.returnCode !== 1) {
        var $containerModal = $(".model-body-capmail");
        var $msgReturn = $containerModal.find(".address-msg");
        var $emailError = $containerModal.find(".address-error");

        if (result.sMessage) {
            $msgReturn.empty().html(result.sMessage);
            $emailError.empty().html(currentEmail);
            $('#verifyEmail').modal('show');
            $.spinner().stop();
        }
    }
}

module.exports = {
    showCapencyVerifyEmailResult: showCapencyVerifyEmailResult
}